<ion-content>
  <div class="content-top-shadow"></div>

  <ion-grid class="grid-no-padding" style="height: 100%">
    <ion-row style="height: 100%">
      <ion-col size="12" size-md="6">
        <div class="slider-content">
          <ion-slides (ionSlideDidChange)="slideChanged()">
            <ion-slide *ngIf="isFindWorkspacePage">
              <h2>Enter your work email</h2>

              <form (ngSubmit)="fetchSubdomainForEmail()">
                <ion-input
                  #emailInput
                  id="unthread-login-work-email-input"
                  placeholder="email@corp.com"
                  [(ngModel)]="email"
                  name="email"
                  [disabled]="isLoading"
                  class="input-field tall-input"
                ></ion-input>
                <ion-button
                  type="submit"
                  color="primary"
                  [disabled]="isLoading || !email.length"
                  id="unthread-login-work-email-btn"
                  class="btn-large"
                >
                  <ion-spinner
                    name="crescent"
                    class="loading-spinner"
                    [hidden]="!isLoading"
                  ></ion-spinner>
                  <span [hidden]="isLoading">Next</span>
                  <ion-icon
                    name="arrow-forward-outline"
                    class="icon-padded-left"
                  ></ion-icon>
                </ion-button>
              </form>

              <div class="business-button-wrapper">
                <p class="business-button" *ngIf="isPublicSite">
                  <a (click)="openMarketingSignupPage()"
                    >Don't have a company workspace?</a
                  >
                </p>
              </div>
            </ion-slide>

            <ion-slide
              *ngIf="!isPhoneAuth && isMainPage"
              style="
                background: var(--ion-item-background);
                border: 1px solid var(--ion-color-step-100);
                border-radius: 8px;
              "
            >
              <ng-container *ngIf="isInvalidSubdomain">
                <ion-icon
                  name="business-outline"
                  style="font-size: 4rem; opacity: 0.5"
                ></ion-icon>
                <h2>No account found here</h2>
                <ion-button
                  (click)="openMarketingSignupPage()"
                  size="block"
                  class="btn-large"
                  style="margin: 20px 0"
                  >Sign up for an Unthread account</ion-button
                >
              </ng-container>
              <ng-container *ngIf="!isInvalidSubdomain">
                <h2>Log in or sign up to get started</h2>
                <p *ngIf="showThirdPartyCookieWarning">
                  Third party cookies are disabled in your browser. You may not
                  be able to login unless third party cookies are enabled.
                </p>
              </ng-container>

              <ion-button
                id="google-login-btn"
                *ngIf="hasGoogleAuthProvider()"
                expand="block"
                (click)="authGoogle()"
                [disabled]="isLoading"
                class="btn-large auth-provider-button"
              >
                <ion-icon name="logo-google" class="padded-icon"></ion-icon>
                Log in with Google
              </ion-button>

              <ion-button
                *ngIf="getGenericSSOProvider()"
                expand="block"
                (click)="authGenericSSO()"
                [disabled]="isLoading"
                class="btn-large auth-provider-button"
              >
                Log in with SSO
              </ion-button>

              <ion-button
                *ngIf="hasOktaOidcAuthProvider()"
                expand="block"
                (click)="authOktaOidc()"
                [disabled]="isLoading"
                class="btn-large auth-provider-button"
              >
                Log in with Okta
              </ion-button>

              <ion-button
                *ngIf="hasOktaSamlAuthProvider()"
                expand="block"
                (click)="authOktaSaml()"
                [disabled]="isLoading"
                class="btn-large auth-provider-button"
              >
                Log in with Okta
              </ion-button>

              <ion-button
                *ngIf="hasMicrosoftAuthProvider()"
                expand="block"
                (click)="authMicrosoft()"
                [disabled]="isLoading"
                class="btn-large auth-provider-button"
              >
                Log in with SSO
              </ion-button>

              <div *ngIf="hasPasswordAuthProvider()" class="auth-item">
                <p
                  style="margin-bottom: 5px"
                  *ngIf="
                    hasGoogleAuthProvider() ||
                    hasOktaOidcAuthProvider() ||
                    hasOktaSamlAuthProvider() ||
                    getGenericSSOProvider()
                  "
                >
                  Or use your email
                </p>
                <p
                  style="margin-bottom: 5px"
                  *ngIf="
                    !hasGoogleAuthProvider() &&
                    !hasOktaOidcAuthProvider() &&
                    !hasOktaSamlAuthProvider() &&
                    !getGenericSSOProvider()
                  "
                >
                  Use your email
                </p>
                <ion-input
                  #emailInput
                  id="unthread-login-email-input"
                  placeholder="email@corp.com"
                  [(ngModel)]="email"
                  name="email"
                  (keyup.enter)="next()"
                  [disabled]="isLoading"
                  class="input-field"
                ></ion-input>
                <ion-button
                  color="primary"
                  (click)="next()"
                  [disabled]="isLoading || !email.length"
                  slot="end"
                  id="unthread-login-next-btn"
                >
                  <ion-spinner
                    name="crescent"
                    class="loading-spinner"
                    [hidden]="!isLoading"
                  ></ion-spinner>
                  <span [hidden]="isLoading">Next </span>
                  <span [hidden]="!isLoading">Authenticating...</span>
                  <ion-icon name="arrow-forward-outline" slot="end"></ion-icon>
                </ion-button>
              </div>

              <div class="business-button-wrapper">
                <p class="business-button" *ngIf="hasPhoneAuthProvider()">
                  Do you hate passwords?
                  <a (click)="isPhoneAuth = true">Use your phone</a>
                </p>
                <p class="business-button" *ngIf="isPublicSite">
                  <a (click)="changePage('findWorkspace')"
                    >Looking for your company's workspace?</a
                  >
                </p>
              </div>
            </ion-slide>

            <ion-slide *ngIf="!isPhoneAuth && !accountExists && isMainPage">
              <h2>Finish creating your account</h2>
              <p style="margin-top: -7px">It takes only a minute</p>

              <ion-card class="outline-card auth-separator">
                <div class="profile-photo-container" *ngIf="provider">
                  <div class="profile-photo">
                    <img
                      *ngIf="authService.userPhoto"
                      [src]="authService.userPhoto"
                    />
                    <div *ngIf="!authService.userPhoto">
                      <label
                        for="profile-file-upload"
                        class="custom-file-upload"
                      >
                        <ion-icon name="camera-outline"></ion-icon>
                      </label>
                      <input
                        id="profile-file-upload"
                        accept="image/png, image/jpeg, image/jpg"
                        type="file"
                        (change)="detectProfilePhotoUpload($event)"
                      />
                    </div>
                  </div>
                </div>

                <form (ngSubmit)="createBizAccount()">
                  <div *ngIf="!provider">
                    <span class="input-label">Name</span>
                    <ion-input
                      #firstNameInput
                      placeholder="First name"
                      [(ngModel)]="firstName"
                      name="firstName"
                      [disabled]="isLoading"
                      class="input-field tall-input"
                    ></ion-input>
                    <ion-input
                      #lastNameInput
                      placeholder="Last name"
                      [(ngModel)]="lastName"
                      name="lastName"
                      [disabled]="isLoading"
                      class="input-field tall-input"
                    ></ion-input>
                    <div *ngIf="authService.phoneNumberRequirement !== 'none'">
                      <span class="input-label">Phone number</span>
                      <ion-input
                        #phoneInput
                        placeholder="(555) 867-5309"
                        [(ngModel)]="phone"
                        name="phone"
                        [readonly]="isLoading || isPhoneConfirmed"
                        class="input-field"
                      >
                        <ion-select
                          [(ngModel)]="countryCode"
                          name="countryCode"
                          interface="popover"
                        >
                          <ion-select-option
                            *ngFor="let country of countries"
                            [value]="country.prefix"
                            >{{ country.emoji }}
                            {{ country.prefix }}</ion-select-option
                          >
                        </ion-select>
                      </ion-input>
                    </div>
                    <span class="input-label">Password</span>
                    <ion-input
                      #passwordInput
                      placeholder="Password"
                      type="password"
                      [(ngModel)]="password"
                      name="password"
                      [disabled]="isLoading"
                      class="input-field tall-input"
                    ></ion-input>
                    <ion-input
                      #passwordConfirmInput
                      placeholder="Confirm password"
                      type="password"
                      [(ngModel)]="passwordConfirm"
                      name="passwordConfirm"
                      [disabled]="isLoading"
                      class="input-field tall-input"
                    ></ion-input>
                  </div>

                  <div style="margin-top: 18px">
                    <app-response-input
                      [responseInputFields]="customSignupFields"
                      [showPublicOption]="true"
                    >
                    </app-response-input>
                  </div>

                  <div
                    class="terms-and-conditions"
                    *ngIf="!authService.tenantId"
                  >
                    <ion-checkbox
                      color="light"
                      checked="true"
                      [(ngModel)]="isAcceptingTerms"
                      name="isAcceptingTerms"
                    ></ion-checkbox>
                    <span
                      >I agree to
                      <a href="https://bit.ly/turnout-terms" target="_blank"
                        >terms & conditions</a
                      >
                      and
                      <a href="https://unthread.io/privacy" target="_blank"
                        >privacy policy</a
                      ></span
                    >
                  </div>

                  <ion-button
                    type="button"
                    fill="clear"
                    (click)="back()"
                    [disabled]="isLoading"
                  >
                    <ion-icon
                      class="icon-padded"
                      name="arrow-back-outline"
                    ></ion-icon>
                    Back
                  </ion-button>
                  <ion-button
                    type="submit"
                    color="primary"
                    class="btn-large"
                    [disabled]="isLoading"
                  >
                    <ion-spinner
                      name="crescent"
                      class="loading-spinner"
                      [hidden]="!isLoading"
                    ></ion-spinner>
                    <span [hidden]="isLoading">Create my account </span>
                    <span [hidden]="!isLoading">Creating...</span>
                  </ion-button>
                </form>
              </ion-card>
            </ion-slide>

            <ion-slide *ngIf="!isPhoneAuth && accountExists && isMainPage">
              <h2>Sign in as {{ email }}</h2>
              <p>Enter your same password</p>

              <form (ngSubmit)="loginEmailPassword(false)">
                <ion-input
                  #passwordInput
                  id="unthread-login-password-input"
                  placeholder="•••••••••"
                  type="password"
                  [(ngModel)]="password"
                  name="password"
                  [disabled]="isLoading"
                  class="input-field tall-input"
                ></ion-input>

                <ion-button
                  type="submit"
                  color="primary"
                  [disabled]="isLoading"
                  id="unthread-login-finish-btn"
                  class="btn-large"
                >
                  <ion-spinner
                    name="crescent"
                    class="loading-spinner"
                    [hidden]="!isLoading"
                  ></ion-spinner>
                  <span [hidden]="isLoading">Log me in </span>
                  <span [hidden]="!isLoading">Logging in...</span>
                </ion-button>
                <ion-button
                  fill="clear"
                  (click)="forgotPassword()"
                  [disabled]="isLoading"
                >
                  Forgot password
                </ion-button>
                <br />
                <ion-button
                  fill="clear"
                  (click)="back()"
                  [disabled]="isLoading"
                >
                  <ion-icon
                    class="icon-padded"
                    name="arrow-back-outline"
                  ></ion-icon>
                  Back
                </ion-button>
              </form>
            </ion-slide>

            <ion-slide *ngIf="isPhoneAuth && isMainPage">
              <h2>{{ title }}</h2>
              <p>{{ numberSubtitle }}</p>
              <ion-input
                #phoneInput
                placeholder="(555) 867-5309"
                [(ngModel)]="phone"
                name="phone"
                (keyup.enter)="next()"
                [readonly]="isLoading || isPhoneConfirmed"
                class="input-field tall-input"
              >
                <ion-select
                  [(ngModel)]="countryCode"
                  name="countryCode"
                  interface="popover"
                >
                  <ion-select-option
                    *ngFor="let country of countries"
                    [value]="country.prefix"
                    >{{ country.emoji }} {{ country.prefix }}</ion-select-option
                  >
                </ion-select>
              </ion-input>
              <ion-button
                color="primary"
                (click)="next()"
                [disabled]="isLoading"
                class="btn-large"
              >
                <ion-spinner
                  name="crescent"
                  class="loading-spinner"
                  [hidden]="!isLoading"
                ></ion-spinner>
                <span [hidden]="isLoading">Send confirmation </span>
                <span [hidden]="!isLoading">Sending...</span>
                <ion-icon
                  name="arrow-forward-outline"
                  class="icon-padded-left"
                ></ion-icon>
              </ion-button>
              <p class="business-button" *ngIf="hasPasswordAuthProvider()">
                Want other login options?
                <a (click)="isPhoneAuth = false">Use your email</a>
              </p>
            </ion-slide>

            <ion-slide *ngIf="isPhoneAuth && isMainPage">
              <h2>What's the code?</h2>
              <p>Enter the code we sent to {{ phone }}.</p>
              <ion-input
                #codeInput
                placeholder="123456"
                type="number"
                pattern="[0-9]*"
                [(ngModel)]="code"
                name="code"
                (keyup.enter)="next()"
                [readonly]="isLoading"
                class="input-field tall-input"
              ></ion-input>
              <ion-button
                fill="clear"
                (click)="back()"
                [disabled]="isLoading"
                class="btn-large"
              >
                <ion-icon
                  class="icon-padded"
                  name="arrow-back-outline"
                ></ion-icon>
                Back
              </ion-button>
              <ion-button
                (click)="next()"
                [disabled]="isLoading"
                class="btn-large"
              >
                <ion-spinner
                  name="crescent"
                  class="loading-spinner"
                  [hidden]="!isLoading"
                ></ion-spinner>
                <span [hidden]="isLoading">Confirm</span>
                <span [hidden]="!isLoading">Confirming...</span>
                <ion-icon
                  name="arrow-forward-outline"
                  class="icon-padded-left"
                ></ion-icon>
              </ion-button>
            </ion-slide>

            <ion-slide *ngIf="isPhoneAuth && isMainPage">
              <h2>Name and email</h2>
              <p>{{ nameSubtitle }}</p>
              <ion-input
                #firstNameInput
                placeholder="Michael"
                [(ngModel)]="firstName"
                name="firstName"
                (keyup.enter)="next()"
                [disabled]="isLoading"
                class="bottom-margin input-field tall-input"
              ></ion-input>
              <ion-input
                #lastNameInput
                placeholder="Bluth"
                [(ngModel)]="lastName"
                name="lastName"
                (keyup.enter)="next()"
                [disabled]="isLoading"
                class="bottom-margin input-field tall-input"
              ></ion-input>
              <ion-input
                #emailInput
                placeholder="michael@bluth.com"
                [(ngModel)]="email"
                name="email"
                (keyup.enter)="next()"
                [disabled]="isLoading"
                class="input-field tall-input"
              ></ion-input>

              <div class="terms-and-conditions" *ngIf="!authService.tenantId">
                <ion-checkbox
                  color="light"
                  checked="true"
                  [(ngModel)]="isAcceptingTerms"
                  name="isAcceptingTerms"
                ></ion-checkbox>
                <span
                  >I agree to
                  <a href="https://unthread.io/terms" target="_blank"
                    >terms & conditions</a
                  >
                  and
                  <a href="https://unthread.io/terms" target="_blank"
                    >privacy policy</a
                  ></span
                >
              </div>

              <ion-button
                fill="clear"
                (click)="back()"
                [disabled]="isLoading"
                class="auth-buttons"
              >
                <ion-icon
                  class="padded-icon"
                  name="arrow-back-outline"
                ></ion-icon>
                Back
              </ion-button>
              <ion-button
                (click)="next()"
                [disabled]="isLoading"
                class="auth-buttons"
              >
                <ion-spinner
                  name="crescent"
                  class="loading-spinner"
                  [hidden]="!isLoading"
                ></ion-spinner>
                <span [hidden]="isLoading">{{ buttonTitle }} </span>
                <span [hidden]="!isLoading">Finishing...</span>
                <ion-icon name="checkmark" class="icon-padded-left"></ion-icon>
              </ion-button>
            </ion-slide>
          </ion-slides>
        </div>
      </ion-col>
      <ion-col size="12" size-md="6" class="marketing-pane hidden-md">
        <div class="marketing-pane-content">
          <img
            style="max-width: 400px"
            src="https://assets.unthread.io/assets/imgs/inbox-preview-3.png"
          />
          <span class="marketing-tagline gradient-text">
            Access your Unthread dashboard for conversation history, response
            time analytics, and more
          </span>
          <p class="marketing-quote gradient-text">
            Manage your Slack, email, Teams, and live chat tickets from one
            place, and set up powerful automations to resolve issues instantly.
          </p>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
  <div id="recaptcha-container"></div>
</ion-content>
